import { TableElectoralCardBody } from 'front-office/view-models/electoral-card';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<TableElectoralCardBody, keyof TableElectoralCardBody>[] = [
  {
    id: 'number',
    label: 'Numero servizio',
  },
  {
    id: 'owner',
    label: 'Intestatario',
  },
  {
    id: 'dateRelease',
    label: 'Data rilascio',
  },
  {
    id: 'hourRelease',
    label: 'Ora rilascio',
  },
  {
    id: 'operator',
    label: 'Operatore rilascio',
  },
  {
    id: 'service',
    label: 'Servizio rilascio',
  },
];
